import { postArticulo, putArticulo } from "api/Articulo.service"
import { ArticuloReadingDtoProps } from "api/DTOs/ArticuloReadingDto"
import { CatalogoReadingDtoProps } from "api/DTOs/CatalogoReadingDto"
import { CategoriaReadingDtoProps } from "api/DTOs/CategoriaReadingDto"
import { TIPO_ARTICULO, TipoArticuloType } from "api/Types/TipoArticulo"
import mapCamposPersonalizados from "common/mappers/mapCamposPersonalizados"
import notification from "common/utils/notification"
import { getBodyFormData } from "features/Inventario/services/ArticuloService"
import { withFormik } from "formik"
import { TFunction } from "i18next"
import { nanoid } from "nanoid"
import * as Yup from "yup"
import ArticuloForm from "../ArticuloForm"

interface FormValues {
  id: string | false
  concepto: string
  precioVenta: number
  tipoArticulo: TipoArticuloType
  numeroReferencia: string
  categoriasId: string[]
  catalogosId: string[]
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  FileAsFormFile: any | null
  ficheroId: string | false
  imagenBase64: string | false
  imagenMediaType: string | false
  camposPersonalizados: {
    clave: string | null | undefined
    valor: string | null | undefined
    id?: string
  }[]
  esDeCompra: boolean
  isEdit: boolean
}
interface EditArticuloProps {
  articulo: ArticuloReadingDtoProps | null
  onHide: () => void
  deleteInfiniteQueryAsociarDoc: () => void
  isEdit: boolean
  t: TFunction
}

const validateForm = (t: TFunction) =>
  Yup.object().shape({
    concepto: Yup.string().required(`${t("errors.conceptEmpty")}`),
    numeroReferencia: Yup.string().required(`${t("errors.referenceEmpty")}`),
  })

const EditArticulo = withFormik<EditArticuloProps, FormValues>({
  validateOnMount: true,
  mapPropsToValues: ({ articulo, isEdit }) => {
    return {
      id: articulo?.id ?? false,
      concepto: articulo?.concepto ?? "",
      precioVenta: articulo?.precioVenta ?? 0,
      tipoArticulo: articulo?.tipoArticulo ?? TIPO_ARTICULO.PRODUCTO,
      numeroReferencia: articulo?.numeroReferencia ?? "",
      categoriasId:
        articulo?.categorias
          ?.filter((categoria: CategoriaReadingDtoProps) => categoria.id)
          ?.map((categoria: CategoriaReadingDtoProps) => categoria.id) ?? [],
      catalogosId:
        articulo?.catalogos
          ?.filter((catalogo: CatalogoReadingDtoProps) => catalogo.id)
          .map((catalogo: CatalogoReadingDtoProps) => catalogo.id) ?? [],
      FileAsFormFile: null,
      ficheroId: articulo?.ficheroId ?? false,
      imagenBase64: articulo?.thumbnailBase64 ?? false,
      imagenMediaType: articulo?.thumbnailMediaType ?? false,
      camposPersonalizados:
        articulo?.camposPersonalizados?.map(({ clave, valor }) => ({
          clave,
          valor,
          id: nanoid(),
        })) ?? [],
      esDeCompra: !!articulo?.esDeCompra,
      isEdit,
    }
  },
  validationSchema: ({ t }: EditArticuloProps) => validateForm(t),
  handleSubmit: async (values, { props, setSubmitting }) => {
    setSubmitting(true)

    try {
      const bodyForm = getBodyFormData({
        ...values,
        camposPersonalizados: mapCamposPersonalizados(
          // @ts-expect-error TS(2345): Argument of type '{ id?: string | undefined; clave...
          values?.camposPersonalizados
        ),
        thumbnailBase64: values.imagenBase64,
      })

      !values.isEdit
        ? await postArticulo(bodyForm)
        : await putArticulo(bodyForm)

      notification.success({
        body: `${props.t("errors.editArticleExit")}`,
      })
      props.deleteInfiniteQueryAsociarDoc()
      setSubmitting(false)

      props.onHide()
    } catch (e) {
      setSubmitting(false)
    }
  },
})(ArticuloForm)

export default EditArticulo
